var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLive = function SvgLive(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "currentColor",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "1.5s",
    repeatCount: "indefinite",
    values: "6;10;6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1.5s",
    repeatCount: "indefinite",
    values: "0.6;0;0.6"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLive);
export { ForwardRef as Icon };
export default "img/element-icons/call/live.e7459ec.svg";